  <template>
  <div class="add-documents" :style="{padding: setPadding}">
    <div class="add-documents__header">
      <h3 v-if="title" class="add-documents__header-title">{{ title }}</h3>
      <p v-if="description" class="add-documents__header-subtitle">{{ description }}</p>
      <VDivider v-if="divider" style="margin-bottom: 20px; margin-top: 20px;" />
      <div class="add-documents__form-row_wrap">
        <template
            v-for="(document, index) in files"
            :key="document.filename"
        >
          <VUploadFile
              v-if="files?.[index]"
              :deleteBtn="!deleteBtnDisabled"
              @deleteFile="onDeleteFile(index)"
              v-model="files[index]"
              :namePropertyField="'filename'"
              :disabled="disable"
              :noPreview="noPreview"
          />
        </template>

        <div
            class="add-documents__upload-files-btn"
            :class="showErrors && formErrors ? 'add-documents__form-error' : ''"
            v-if="files?.length < MULTIPLE_SIZE && !deleteBtnDisabled"
        >
          <input
              @change="(event) => changeFile(event)"
              type="file"
              multiple
              :accept="FILE_ACCEPTED"
          />
          <Upload style="margin-right: 4px" />
          Загрузить файл
        </div>
      </div>
      <p
          class="add-documents__form-bottom-inp_error"
          v-if="showErrors && formErrors"
      >
        {{ formErrors }}
      </p>
    </div>
  </div>
</template>
<script setup>
import {FILE_ACCEPTED, FILE_SIZE, FILE_TYPES, MULTIPLE_SIZE} from "@/constants";
import Upload from "@/components/Icons/Upload.vue";
import {onMounted, ref} from "vue";
import eventBus from "@/services/eventBus";
import vacanciesApi from "@/api/vacancies";
import VDivider from "@/components/UI/VDivider/index.vue";

const emit = defineEmits(["update:modelValue"]);
const props = defineProps({
  title: String,
  description: String,
  showErrors: Boolean,
  formErrors: Boolean,
  modelValue: String,
  valueIn: Array,
  deleteBtnDisabled: Boolean,
  disable: Boolean,
  noPreview: Boolean,
  setPadding: {
    type: String,
    default: "24px",
  },
  divider: Boolean,
})
const files = ref([])
const filesId = ref([])
const filesForDelete = ref([]);

const onDeleteFile = (index) => {
  // if (files.value?.[index]?.id) {
  //   filesForDelete.value.push(files.value[index].id);
  // }
  files.value = files.value.filter((_, idx) => idx !== index);
  filesId.value = filesId.value.filter((_, idx) => idx !== index);
  emit("update:modelValue", filesId.value);
};

const changeFile = async (e) => {
  if (e.target?.files?.length > 10) {
    eventBus.emit("errorRequest", {
      title: "Ошибка",
      description: `Прикрепляйте за раз не более ${MULTIPLE_SIZE} файлов`,
    });
    return;
  }
  e.target?.files?.forEach((el) => {
    const file = el;
    const fileSize = file.size / 1024 / 1024;
    const fileType = file.type;
    const formData = new FormData();
    formData.append("label", 'Фотография маршрута');
    formData.append('files[]', el);


    if (!FILE_TYPES.some((type) => fileType.includes(type))) {
      return;
    }
    if(fileSize > FILE_SIZE) {
      eventBus.emit("errorRequest", {
        title: "Ошибка",
        description: `Выберите файл размером меньше чем ${FILE_SIZE} mb`,
      });
    } else {
      sendFile(formData)
    }
  })
  emit("update:modelValue", filesId.value);

}

const sendFile = async (body) => {
  try {
    const response = await vacanciesApi.sendFileAttachments(props.vacancyId, body)
    if (response) {
      files.value.push(response.upload[0])
      filesId.value.push(response.upload[0]?.id)
    }
  } catch (error) {
    console.log(error)
  }
}

const deleteFile = (fileId) => {
  buyingTicketsResponce.value = buyingTicketsResponce.value.filter((el) => {
    return el.id !== fileId
  })
  ticketsData.value.route_memo.files = ticketsData.value.route_memo.files.filter((el) => {
    return el !== fileId
  })
}

onMounted(() => {
  filesId.value = props.modelValue;
  files.value = props.valueIn || []
})
</script>
<style lang="scss" scoped>
.add-documents {
  margin-top: 24px;
  border-radius: 16px;
  background-color: #fff;
  //box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.04);

  &__header-title {
    color: $dark;
    font-size: 20px;
    font-weight: 500;
  }

  &__header-subtitle {
    margin-top: 16px;
    color: $gray;
    font-size: 14px;
  }

  &__form-row {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;
    &_wrap {
      margin-top: 16px;
      display: flex;
      column-gap: 12px;
      row-gap: 16px;
      flex-wrap: wrap;
    }
    &_justify {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
    }
    &_dates {
      display: flex;
      gap: 16px;
      max-width: calc(50% - 8px);
      flex: 1 1 auto;
    }
  }

  &__form-error {
    border: 1px solid $red;
  }

  &__upload-files-btn {
    position: relative;
    width: 185px;
    height: 56px;
    padding: 0 23.5px;
    border-radius: 8px;
    background-color: $secondary-main;
    color: $blue;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;

    img {
      width: 24px;
      margin-right: 8px;
    }

    input {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 2;
      opacity: 0;
      cursor: pointer;
    }
  }
}
</style>